export const FIREBASE_API_KEY="AIzaSyAkrJpw1TC7SNW-el5CQX5JlsPM84e51ek"
export const FIREBASE_AUTH_DOMAIN="gorrion-brief-prod.firebaseapp.com"
export const FIREBASE_DATABASE_URL="https://gorrion-brief-prod.firebaseio.com"
export const FIREBASE_PROJECT_ID="gorrion-brief-prod"
export const FIREBASE_STORAGE_BUCKET="gorrion-brief-prod.appspot.com"
export const HOST_URL="https://product.gorrion.io"
